import { ActionTypes } from "../constants/action-types"

const initialState = {
    uploadNewTutorialTechnology:[]

}

export const UploadTutorialTechnology = (state=initialState, {type, payload})=>{
switch (type){
    case ActionTypes.UPLOAD_TUTORIAL_TECHNOLOGY: 
    return {...state, uploadNewTutorialTechnology: payload}
    default: return state
}

}